import { render, staticRenderFns } from "./ServiceRequestEconomy.vue?vue&type=template&id=144761bd&scoped=true"
import script from "./ServiceRequestEconomy.vue?vue&type=script&lang=js"
export * from "./ServiceRequestEconomy.vue?vue&type=script&lang=js"
import style0 from "./ServiceRequestEconomy.vue?vue&type=style&index=0&id=144761bd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144761bd",
  null
  
)

export default component.exports